import { Button } from "react-bootstrap"
import BaseControl from "./BaseControl"

const ButtonControl = ({
    text="Text",
    caption="",
    buttonLabel="button",
    variant="primary",
    onClicked=()=>{}}) => {
    return <BaseControl text={text} caption={caption}>
            <Button 
                size="sm"
                variant={variant} 
                onClick={ (e) => onClicked()}>
                {buttonLabel}
            </Button>
    </BaseControl>
}

export default ButtonControl